import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Grid,
  Stack,
  Button,
  IconButton,
  useTheme,
  useMediaQuery
} from '@mui/material';
import {
  ArrowBack,
  Menu
} from '@mui/icons-material';
import TempLogo from '../../assets/svgs/temp-logo.svg.js';
import styles from '../landing/LandingPage.module.scss';

const CommonHeader = ({ 
  showBackButton = true, 
  backButtonText = "Back to Home",
  showLoginButton = true,
  loginButtonText = "Login to Platform",
  onBackClick,
  onLoginClick,
  showMenuButton = false,
  onMenuClick
}) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleBack = () => {
    if (onBackClick) {
      onBackClick();
    } else {
      navigate('/');
    }
  };

  const handleLogin = () => {
    if (onLoginClick) {
      onLoginClick();
    } else {
      navigate('/login');
    }
  };

  return (
    <Box className={styles.header}>
      <Container maxWidth="lg">
        <Grid container justifyContent="space-between" alignItems="center" sx={{ py: 2 }}>
          <Grid item>
            {showBackButton && (
              <Button
                startIcon={<ArrowBack />}
                onClick={handleBack}
                sx={{ 
                  color: '#2259c9', 
                  fontWeight: 600,
                  fontSize: { xs: '0.8rem', sm: '0.9rem' },
                  px: { xs: 1, sm: 2 },
                  py: { xs: 0.5, sm: 1 },
                  minWidth: { xs: 'auto', sm: 'auto' }
                }}
              >
                <Box component="span" sx={{ display: { xs: 'none', md: 'inline' } }}>
                  {backButtonText}
                </Box>
                <Box component="span" sx={{ display: { xs: 'inline', md: 'none' } }}>
                  Back
                </Box>
              </Button>
            )}
          </Grid>
          <Grid item>
            <Stack direction="row" spacing={1} alignItems="center">
              <div className={styles.logoContainer}>
                <TempLogo />
              </div>
              {showMenuButton && isMobile && (
                <IconButton
                  onClick={onMenuClick}
                  sx={{ 
                    color: '#2259c9',
                    display: { xs: 'flex', sm: 'none' }
                  }}
                >
                  <Menu />
                </IconButton>
              )}
              {showLoginButton && (
                <Button
                  variant="outlined"
                  size="large"
                  onClick={handleLogin}
                  className={styles.secondaryButton}
                  sx={{
                    fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' },
                    px: { xs: 2, sm: 3, md: 4 },
                    py: { xs: 1, sm: 1.5 },
                    minWidth: { xs: 'auto', sm: 'auto' }
                  }}
                >
                  <Box component="span" sx={{ display: { xs: 'none', md: 'inline' } }}>
                    {loginButtonText}
                  </Box>
                  <Box component="span" sx={{ display: { xs: 'inline', md: 'none' } }}>
                    Login
                  </Box>
                </Button>
              )}
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default CommonHeader; 